import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class RecStatus extends Mappeable {

    idTypeStatusRecommendationPk: number;
    txtTypeStatusRecommendation: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtTypeStatusRecommendation: this.txtTypeStatusRecommendation,
            mrkActive: this.mrkActive
        }
    }


}
